import { yupResolver } from "@hookform/resolvers/yup";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { AppQuill } from "../../../../../Component/Common/Components/FormValidationInputs/AppQuill";
import { toast } from "react-toastify";
import { prescribedMattersValidationSchema } from "./PrescribedMattersValidation";
import { PrescribedMattersService } from "../../../../../Component/Api/EmploymentEquity/Plan/PrescribedMatters/PrescribedMattersService";
import { EEPrescribedMattersDto } from "../../../../../Component/Model/Dto/EmploymentEquity/Plan/EEPrescribedMatters";
import { useRecoilValue } from "recoil";
import { EEScorecardAtom } from "../../../../../State/EEScorecard.Atom";
import { ConsolidationAtom } from "../../../../../State/Consolidation.Atom";
import { UserActivityService } from "../../../../../Component/Api/UserActivity/UserActivityService";
import { PrescribedMattersSection } from "../../../../../Component/Common/Constants/UserActivityTrackingSections";
import { UserActivityActionType } from "../../../../../Component/Model/Enum/BEE123Enums";

interface IProps {
    scorecardId : string;
}

type InputForm = {
    detail?: string;
}

export const PrescribedMatters: FC<IProps> = (props) => {

    const scorecard = useRecoilValue(EEScorecardAtom);
    const isConsolidatedScorecard = useRecoilValue(ConsolidationAtom);
    const maxConsolidatedDetailLength = 6000 * (scorecard.ConsolidationSourceScorecardsCount ?? 1);
    const maxDetailLength = isConsolidatedScorecard ? maxConsolidatedDetailLength : 6000;

    const { control, reset, getValues } = useForm<InputForm>({
        mode: 'all',
        resolver: yupResolver(prescribedMattersValidationSchema(maxDetailLength))
    });

    const getPrescribedMattersData = async (scorecardId: string) => {
        try {
            const dataResponse = await PrescribedMattersService.GetPrescribedMatters(scorecardId);
            const formData: InputForm = {
                detail: dataResponse.data.detail
            }
            reset(formData);
        } catch (error: any) {
            console.log(error);
        }
    }

    const savePrescribedMattersForm = async () => {
        const formData = getValues();

        prescribedMattersValidationSchema(maxDetailLength).validate(formData, { abortEarly: false }).then(async() => {
            const requestData: EEPrescribedMattersDto.Dto = {
                scorecardId: props.scorecardId,
                detail: formData.detail
            }
            const response = await PrescribedMattersService.SavePrescribedMatters(requestData);
        }).catch(function (error: any) {
            toast.error(error.message);
        });
    }

    const prescribedMattersLog = (actionType: number, actionDescription: string) => {
        UserActivityService.createActivityLog({
            section: PrescribedMattersSection,
            actionType: actionType,
            actionDescription: actionDescription,
            scorecardId: props.scorecardId,
            requestUrl: window.location.href
        });
    }
    
    useEffect(() => {
        getPrescribedMattersData(props.scorecardId);
        prescribedMattersLog(UserActivityActionType.View, "View prescribed matters commentary");

        return () => {
            if (localStorage.getItem('coreToken') !== null) {
                savePrescribedMattersForm();
                prescribedMattersLog(UserActivityActionType.Create, "Capture prescribed matters commentary");
            }
        }
    }, [props.scorecardId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box component="form" mt={2}>
            <Box>
                <AppQuill control={control} name='detail' label='Detail*' maxLength={maxDetailLength} />
            </Box>
        </Box>
    )
}